/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface PartnerContentVerification { 
    id: string;
    relayId: number;
    code?: string;
    startDate: Date;
    endDate: Date;
    dateCreated: Date;
    apiBaseUrl?: string;
    apiMethodType?: string;
    grantType?: string;
    apiUserName?: string;
    apiKey?: string;
    apiPassword?: string;
    smppSystemId?: string;
    systemType?: string;
    smppPassword?: string;
    smppIpAddress?: string;
    smppPort?: string;
    serviceProviderId?: string;
    partnerId: number;
}
